import { ProblemDetails } from '../../models/error-responses/problem-details.model';

export class BaseErrorResponseHandler {
  baseErrorMessage(problem: ProblemDetails | undefined): string {
    const detail: string | undefined = problem?.detail;
    if (detail) {
      return detail.trim();
    }

    const title: string | undefined = problem?.title;
    if (title) {
      return title.trim();
    }

    return '';
  }
}
